import { createLogger } from "logging";
import React, { useEffect } from "react";
import { useLocation } from "react-router";

const logger = createLogger("FixTooltips");

function hideTooltips() {
  let elements = document.getElementsByClassName("global-tooltip");
  if (!elements.length) return;
  logger.trace(`hideTooltips(): ${elements.length}`);

  for (const i in elements) {
    try {
      const element = elements[i];
      element.parentElement?.removeChild(element);
    } catch (ex) {
      logger.trace(`hideTooltips(): Failed to remove`, ex);
    }
  }

  elements = document.getElementsByClassName("global-tooltip");
  if (elements.length) {
    logger.trace(`hideTooltips(): Still ${elements.length} active tooltips found!`);
    setTimeout(() => hideTooltips(), 50);
  }
}

export const FixTooltips: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    hideTooltips();
  }, [location]);
  return null;
};
